module.exports = __webpack_public_path__ + "img/14.63470cc8.jpg";